/* Quantite : largeur des champs adaptee au contenu (unite collee au chiffre), libelle de droite
   synchronise avec .qty-label, et saisie au clavier differee (le theme ne recalcule qu'une fois la
   saisie terminee : pause de 1,2 s, OK/Entree, ou sortie du champ).
   Unites : libelle pose en Liquid (data-unit-label, snippets/unit-label.liquid) ; le detail du prix
   ("Voir en details", assets/bundle.product.js) ecrit "m²" / "mL" en dur : remplace par ce libelle. */
(function () {
  if (window.__mpnQtyUnits) return; window.__mpnQtyUnits = true;

  var SEL = 'quantity-calculator .mpn-qty-grid input.volume__input, quantity-calculator .mpn-qty-grid input.quantity__input';
  var DELAY = 1200;

  function size(inp) {
    var l = String(inp.value || '').length || 1;
    var w = Math.max(2, l + 0.4) + 'ch';
    if (inp.style.width !== w) inp.style.width = w;
  }
  function linear() {
    var d = document.getElementById('calculator-data');
    var lab = d && d.getAttribute('data-unit-label');
    if (!lab) return;
    document.querySelectorAll('[data-detail-surface]').forEach(function (el) {
      var t = el.textContent, n = t.replace(/\s(m²|mL)$/, ' ' + lab);
      if (n !== t) el.textContent = n;
    });
  }
  /* Pluriel du conditionnement dans la case (« 1 boîte » / « 2 boîtes », « 3 lots de 2 dalles ») :
     les fiches portent le mot au singulier, la regle est ici, une seule fois. */
  var LOC = window.__mpnPqLoc;
  function plural(s, n) {
    s = String(s || '').trim();
    if (!s || !(n > 1)) return s;
    var w = s.split(' '), f = w[0], lf = f.toLowerCase();
    if (/^(m[²³23]|ml|m|sqm|lm|lfm)$/i.test(s) || /[²³]/.test(f)) return s;
    if (LOC === 'de') {
      var D = { karton: 'Kartons', palette: 'Paletten', platte: 'Platten', sack: 'Säcke', paket: 'Pakete', modul: 'Module', kartusche: 'Kartuschen', tonne: 'Tonnen', 'sprühflasche': 'Sprühflaschen', spraydose: 'Spraydosen', spray: 'Sprays' };
      if (lf === 'big') return s.replace(/Bag\b/, 'Bags');
      if (D[lf]) w[0] = D[lf];
      return w.join(' ');
    }
    var es = function (x) { return x + (/(s|x|z|ch|sh)$/i.test(x) ? 'es' : 's'); };
    if (LOC === 'en') {
      if (/\d/.test(f)) { w[w.length - 1] = es(w[w.length - 1]); return w.join(' '); }
      if ((lf === 'big' || lf === 'bulk') && w[1]) { w[1] = es(w[1]); return w.join(' '); }
      w[0] = es(f); return w.join(' ');
    }
    if (/\d/.test(f)) return s;
    if (lf === 'big' && w[1]) { w[1] = w[1] + 's'; return w.join(' '); }
    var X = { seau: 'seaux', panneau: 'panneaux' };
    if (X[lf]) w[0] = X[lf]; else if (!/[sxz]$/i.test(f)) w[0] = f + 's';
    return w.join(' ');
  }
  function tick() {
    document.querySelectorAll('quantity-calculator .mpn-qty-grid').forEach(function (grid) {
      grid.querySelectorAll('quantity-volume input, quantity-input input').forEach(size);
      var dst = grid.querySelector('[data-mpn-unit-for="piece"]');
      var qi = grid.querySelector('quantity-input input');
      if (dst && dst.getAttribute('data-sg')) {
        var t = plural(dst.getAttribute('data-sg'), qi ? parseFloat(qi.value) : 1);
        if (dst.textContent !== t) dst.textContent = t;
      }
    });
    linear();
  }

  function flush(inp) {
    if (!inp || !inp.__mpnPending) return;
    clearTimeout(inp.__mpnTimer);
    inp.__mpnPending = false;
    if (inp.value === '' || isNaN(parseFloat(String(inp.value).replace(',', '.')))) return;
    inp.__mpnRelease = true;
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
    inp.__mpnRelease = false;
    tick();
  }

  document.addEventListener('input', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches(SEL)) { tick(); return; }
    size(inp);
    if (inp.__mpnRelease || !e.isTrusted) return;
    e.stopImmediatePropagation();
    inp.__mpnPending = true;
    clearTimeout(inp.__mpnTimer);
    inp.__mpnTimer = setTimeout(function () { flush(inp); }, DELAY);
  }, true);

  ['change', 'keyup'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var inp = e.target;
      if (!inp.matches || !inp.matches(SEL)) { if (type === 'change') setTimeout(tick, 0); return; }
      if (inp.__mpnRelease || !e.isTrusted) return;
      if (type === 'keyup' && (e.key === 'Enter' || e.keyCode === 13)) { flush(inp); return; }
      if (inp.__mpnPending) { e.stopImmediatePropagation(); if (type === 'change') flush(inp); }
    }, true);
  });

  document.addEventListener('keydown', function (e) {
    var inp = e.target;
    if (inp.matches && inp.matches(SEL) && (e.key === 'Enter' || e.keyCode === 13)) {
      e.preventDefault();
      flush(inp);
      inp.blur();
    }
  }, true);
  document.addEventListener('blur', function (e) {
    var inp = e.target;
    if (inp.matches && inp.matches(SEL)) flush(inp);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mpn-qty-grid .quantity__button');
    if (btn) {
      var box = btn.closest('quantity-volume, quantity-input');
      var inp = box && box.querySelector('input');
      if (inp && inp.__mpnPending) flush(inp);
    }
    var u = e.target.closest && e.target.closest('.mpn-qty-grid .mpn-qty-unit');
    if (u) { var i2 = u.parentElement.querySelector('input'); if (i2) i2.focus(); }
    setTimeout(tick, 50);
  }, true);

  /* Clic dans une case : tout le chiffre est selectionne, on tape directement la nouvelle valeur (demande d'Ed, oct. 2026) */
  function selAll(inp) { try { inp.select(); } catch (x) {} }
  document.addEventListener('focus', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches(SEL)) return;
    inp.__mpnSel = true;
    selAll(inp);
    setTimeout(function () { selAll(inp); }, 0);
  }, true);
  document.addEventListener('mouseup', function (e) {
    var inp = e.target;
    if (inp.matches && inp.matches(SEL) && inp.__mpnSel) { e.preventDefault(); inp.__mpnSel = false; selAll(inp); }
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
  setInterval(tick, 300);
})();
